import { createFileRoute, redirect } from '@tanstack/react-router';

import { runLineageSearchSchema } from '~/features/catalog-enrichment/utils/lineage-images-search';

/**
 * The old "Lineage" tab no longer exists: its listing × stage grid is now the Products tab's
 * "Listings" view, and its issues-by-reason view is the new Issues tab. This route only keeps
 * old links working — `/lineage` → Products › Listings, `/lineage?view=issues` → Issues, `/lineage?listing=`
 * → that listing in Products › Listings — it renders nothing of its own.
 */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/lineage',
)({
  validateSearch: runLineageSearchSchema,
  beforeLoad: ({ params, search }) => {
    if (search.view === 'issues') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect
      throw redirect({
        to: '/catalog-enrichment/runs/$runId/issues',
        params: { runId: params.runId },
        replace: true,
      });
    }
    if (search.listing) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect
      throw redirect({
        to: '/catalog-enrichment/runs/$runId/products/listings',
        params: { runId: params.runId },
        search: { listing: search.listing },
        replace: true,
      });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router's redirect
    throw redirect({
      to: '/catalog-enrichment/runs/$runId/products/listings',
      params: { runId: params.runId },
      // A stage/status/disposition filter carries over into the Listings view.
      search: {
        ...(search.stage ? { stage: search.stage } : {}),
        ...(search.status ? { status: search.status } : {}),
        ...(search.disposition ? { disposition: search.disposition } : {}),
      },
      replace: true,
    });
  },
});
